export default __webpack_public_path__ + "static/media/4.4c5b9b25.png";